<template>
  <v-menu
    v-model="datePickerMenu"
    :close-on-click="false"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="270px"
    content-class="bg-white"
  >
    <template #activator="{ on, attrs }">
      <v-row>
        <v-col
          cols="12"
          lg="6">
          <v-text-field
            v-model="dateText"
            :label="label"
            outlined
            dense
            readonly
            color="secondary"
            :disabled="disabled"
            v-bind="attrs"
            hide-details
            v-on="on" />
        </v-col>
        <v-col
          cols="6"
          lg="3">
          <v-autocomplete
            v-model="dateTime.hour"
            label="Hour"
            outlined
            dense
            color="secondary"
            :disabled="disabled"
            v-bind="attrs"
            :items="Array.from({length: 24}, (_, i) => i.toString().padStart(2, '0'))"
            hide-details />
        </v-col>
        <v-col
          cols="6"
          lg="3">
          <v-autocomplete
            v-model="dateTime.minute"
            label="Minute"
            outlined
            dense
            color="secondary"
            :disabled="disabled"
            v-bind="attrs"
            :items="Array.from({length: 60}, (_, i) => i.toString().padStart(2, '0'))"
            hide-details />
        </v-col>
      </v-row>
    </template>
    <v-date-picker
      v-model="dateTime.date"
      color="secondary">
      <v-spacer />
      <v-btn
        text
        small
        color="secondary"
        @click="dateTimePickerClose()">
        Submit
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Date'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      datePickerMenu: false,
      date: {
        date: this.$dayjs().format('YYYY-MM-DD'),
        hour: this.$dayjs().format('HH'),
        minute: this.$dayjs().format('mm')
      }
    }
  },
  computed: {
    dateTime: {
      get () {
        return this.date
      },
      set (val) {
        this.date = val
      }
    },
    dateText () {
      return this.$dayjs(this.dateTime.date).format('DD-MM-YYYY')
    }
  },
  watch: {
    date: {
      handler (val) {
        this.$emit('input', this.$dayjs(`${val.date} ${val.hour}:${val.minute}`).utc().toISOString())
      },
      deep: true
    }
  },
  mounted () {
    this.initDate()
  },
  methods: {
    initDate () {
      if (this.value) {
        this.date = {
          date: this.$dayjs(this.value).format('YYYY-MM-DD'),
          hour: this.$dayjs(this.value).format('HH'),
          minute: this.$dayjs(this.value).format('mm')
        }
      }
    },
    dateTimePickerClose () {
      this.datePickerMenu = false
    }
  }
}
</script>

<style  scoped>
.bg-white {
  background-color: white !important;
}
</style>
